export const nl = {
  AanvraagDocumentS1Title: "Aanvraag CAK-verzekering in het buitenland",
  Advies: "Advies",
  BekijkHetAdvies: "Bekijk het advies",
  BestaatUit10DigitsTekst:
    "U heeft het invulveld '{{label}}' niet juist ingevuld. Het veld moet 10 cijfers bevatten.",
  BsnValidationFactoryText:
    "U heeft het invulveld '{{label}}' niet juist ingevuld. Het burgerservicenummer bestaat uit 9 cijfers.",
  CAKIDnummer: "CAK ID-nummer",
  CAKIDnummerInfoTxt:
    "Dit nummer staat op de brief die u van ons krijgt bij inschrijving. Het bestaat uit 8 cijfers (begin met een 0 als u maar 7 cijfers heeft). Elk gezinslid heeft een eigen CAK ID-nummer.",
  ClientGenericError: "Er is een storing",
  ClientTimeoutError: "Door een timeout zijn er geen gegevens",
  DateNotInFutureValidationFactoryText:
    "U heeft in het invulveld '{{label}}' een toekomstige datum ingevuld.",
  DateNotInPastValidationFactoryText:
    "U heeft in het invulveld '{{label}}' een datum in het verleden ingevuld.",
  DateValidationFactoryValidationText: "U heeft in het invulveld '{{label}}' geen juiste datum ingevuld.",
  IkGa90DagenOfKorterOpReis: "Ik ga 90 dagen of korter op reis",
  IkGa91DagenOfLangerOpReis: "Ik ga 91 dagen of langer op reis",
  IsDecimalValidationText: "U heeft het invulveld '{{label}}' niet juist ingevuld. Het is geen geldig getal.",
  IntegerValidationText: "U heeft het invulveld '{{label}}' niet juist ingevuld. Het is geen geldig getal.",
  EhicFormulier: "EHIC aanvragen",
  UwAanvraagIsVerstuurd: "Uw aanvraag is verstuurd.",
  EmailAdres: "E-mailadres",
  EmailAdresControle: "Herhaal e-mailadres",
  EmailAdresInfoTxt: "Wij gebruiken dit e-mailadres als wij contact met u willen opnemen over uw bericht.",
  GeboorteDatum: "Geboortedatum (dd-mm-jjjj)",
  HasSpecificLengthyValidationText: `U heeft het invulveld '{{label}}' niet juist ingevuld. Het veld moet {{specificAmount}} cijfers bevatten.`,
  HoeveelDagenGaatUInTotaalOpReis: "Hoeveel dagen gaat u in totaal op reis?",
  IsDecimalValidationFactoryText:
    "U heeft het invulveld '{{label}}' niet juist ingevuld. Het mag aleen cijfers bevatten.",
  IsKlantKaartDecimalValidationFactoryText:
    "U heeft het invulveld '{{label}}' niet juist ingevuld. Het klantnummer mag maximaal 10 cijfers bevatten.",
  IsIbanValidationFactoryValidationText:
    "U heeft het invulveld '{{label}}' niet juist ingevuld, voorbeeld: NL01ABCD0123456789 (vervangen door uw eigen IBAN).",
  IsPostcodeValidationFactoryValidationText:
    "U heeft het invulveld '{{label}}' niet juist ingevuld, voorbeeld: 1234AA (vervangen door uw eigen postcode).",
  IsRequiredValidationFactoryValidationText: "U heeft het invulveld '{{label}}' niet ingevuld.",
  Ja: "Ja",
  KiesEenLand: "Kies een land",
  Maximaal5BijlagenMaximaal5MBPerBijlage: "Maximaal 5 bijlagen, maximaal 5 MB per bijlage.",
  Nee: "Nee",
  MedicijnenOpReis: "Medicijnen op reis",
  MedicijnenMeeOpReisHulp: "Medicijnen mee op reis-hulp",
  MedicijnenOpReisTitle: "Heb ik een medicijnverklaring nodig?",
  MeldingNoteerNummerVoorVerzending:
    "Noteer het nummer dat verschijnt na het versturen. Heeft u nog vragen? Geef dan dit nummer door. Zo kunnen wij u beter helpen.",
  MeldingNoteerNummerNaVerzending:
    "Noteer bovenstaand nummer. Heeft u nog vragen? Geef dan dit nummer door. Zo kunnen wij u beter helpen.",
  MinimumBedragInfoTxt:
    "Het minimumbedrag voor een betalingsregeling is € 10 per maand. Kunt u dit niet missen? Neem dan telefonisch contact met ons op.",
  MijnGegevens: "Mijn gegevens",
  NaarWelkeLandenGaatUOpReis: "Naar welk(e) land(en) gaat u op reis? (maximaal 6 landen)",
  NaarOnzeHomepage: "Naar onze homepage",
  Omschrijving: "Omschrijving",
  RepeatEmailAdresValidationError: `U heeft in het invulveld '{{label}}' niet het juiste e-mail adres ingevuld. Het moet hetzelfde zijn als in het veld 'E-mailadres'.`,
  VerplichtVeldIsNietIngevuldTijdensVerzenden: "Verplicht veld is niet ingevuld tijdens verzenden",
  VulUwGegevensIn: "Vul uw gegevens in",
  SchengenFormulier: "Mijn ingevulde en ondertekende medicijnverklaring digitaal opsturen",
  WelkeVerklaringKanIkDigitaalOpsturen: "Welke verklaring kan ik digitaal opsturen?",
  WanneerOntvangIkDeGoedgekeurdeVerklaring: "Wanneer ontvang ik de goedgekeurde verklaring?",
  ValtUwMedicijnOnderDeNederlandseOpiumwet: "Valt uw medicijn onder de Nederlandse opiumwet?",
  WatIsDeWerkzameStofVanUwMedicijn: "Wat is de werkzame stof van uw medicijn?",
  VertrekDatum: "Vertrekdatum (dd-mm-jjjj)",
  Voorletters: "Voorletter(s)",
  VolgendLand: "Nog een land",
  Vraag1UwMedicijn: "Vraag 1: Uw medicijn(en)",
  WerkzameStofValidatie:
    "U moet een werkzame stof selecteren. Staat uw medicijn er niet bij? Neem dan contact op met de ambassade of het consulaat van het land waar u naartoe reist.",
  WerkzameStofBijsluiter:
    "De werkzame stof van uw medicijn vindt u in de bijsluiter. Of vraag dit aan uw (huis)arts of apotheker.",
  Vraag2UwReis: "Vraag 2: Uw reis",
  Vraag3DeReisduur: "Vraag 3: Reisduur",
  Vraag4Persoon: "Vraag 4: Gegevens van de gebruiker",
  Vraag5WerkzameStof: "Vraag 5: Medicijngegevens",
  Achternaam: "Achternaam",
  Telefoonnummer: "Telefoonnummer",
  Opmerking: "Opmerking",
  BevestigingEmail: "Wilt u een bevestiging op uw e-mailadres ontvangen?",
  SublabelVraag4:
    "U heeft één of meerdere medicijnverklaringen nodig. Die kunt u downloaden nadat u alle onderstaande gegevens heeft ingevuld.",
  GegevensMedicatieGebruiker: "Vul hier de gegevens in van degene die de medicatie gebruikt.",
  Voornaam: "Voornaam",
  Adres: "Adres",
  Postcode: "Postcode",
  Woonplaats: "Woonplaats",
  Geboorteplaats: "Geboorteplaats",
  Geboortedatum: "Geboortedatum",
  Geslacht: "Geslacht",
  NummerPaspoort: "Nummer paspoort",
  Nationaliteit: "Nationaliteit",
  Vraag5Reisgegevens: "Vraag 5: Gegevens over de reis",
  Reisbestemming: "Reisbestemming",
  DatumVertrekUitNl: "Datum vertrek uit Nederland",
  DatumTerugInNl: "Datum terug in Nederland",
  Reisduur: "Reisduur",
  MaximalAmountValidationMessage: "Uw reisduur is langer dan 90 dagen. Ga terug naar vraag 3.",
  VolgendWerkzameStof: "Voeg nog een medicijn toe",
  WerkzameStof: "Werkzame stof",
  HandelsnaamMerknaam: "Handelsnaam/merknaam",
  HandelsnaamMerknaamPopup: "Die vindt u op de verpakking. Of vraag uw (huis)arts of apotheker.",
  FarmaceutischeVorm: "Farmaceutische vorm",
  FarmaceutischeVormPopup: "Soort medicijn, bijvoorbeeld pillen, druppels of pleisters.",
  ConcentratieVanDeWerkzameStof: "Concentratie van de werkzame stof",
  ConcentratieVanDeWerkzameStofPopup: "Die vindt u op de verpakking. Of vraag uw (huis)arts of apotheker.",
  GebruiksaanwijzigingDagdosering: "Gebruiksaanwijziging/dagdosering",
  GebruiksaanwijzigingDagdoseringPopup:
    "Hoeveelheid per dag, bijvoorbeeld aantal milligram (mg) of milliliter (ml).",
  Opmerkingen: "Opmerkingen",
  TotaleHoeveelheidMeeOpReis: "Totale hoeveelheid mee op reis",
  SchengenMedicijnverklaringFormulierStapMedicijnverklaring: "Medicijnverklaring",
  IkGaNaarAruba: "Ik ga naar Aruba",
  IkGaNaarCuracao: "Ik ga naar Curaçao",
  BijlageInfoText:
    "Maximaal {{maxAmount}} bijlage(n), maximaal {{maxSizeInMB}} MB per bijlage. Toegestane bestandstypen: {{extensions}}.",
  AnderLand: "Ander land",
  Inleiding: "Inleiding"
};
